import React from "react";
import { roles } from "shared/constants/Constants.js";

const fleetRoutes = {
  dashboard: [
    {
      path: "approved_cars/:table?",
      /** Sidebar link with default table so useParams().table is set (no change in FleetList). */
      sidebarPath: "approved_cars/approved_cars",
      /** Base path for sidebar active state so List stays active for any /approved_cars/... */
      sidebarBasePath: "approved_cars",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "approved-cars-dashboard" */
          "../../feature/fleet/dashboard/FleetList.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.DRIVER_MANAGER,
        roles.FINANCE,
        roles.PROCUREMENT,
        roles.PARKING,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
        roles.PROCUREMENT_ADMIN,
        roles.COMMERCIAL,
        roles.HUB_PROCUREMENT,
        roles.FLEET_EXECUTIVE,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "parkingList",
      sidebarLabel: "List",
      countKey: "total_fleet_count",
    },
    {
      path: "procurement_request",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "procurement-request-dashboard" */
          "../../feature/fleet/dashboard/FleetProcurement.js"
        ).then((m) => ({
          default: () => React.createElement(m.default, { sidebarListClick: "" }),
        })),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.PROCUREMENT,
        roles.PARKING,
        roles.PROCUREMENT_ADMIN,
      ],
      sidebarGroup: "parkingList",
      sidebarLabel: "Procurement",
      countKey: "total_procurement_count",
    },
    {
      path: "car_handover",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "car-handover-dashboard" */
          "../../feature/fleet/dashboard/FleetHandover.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.PARKING, roles.ADMIN],
      sidebarGroup: "parkingList",
      sidebarLabel: "Car Handover",
      countKey: "handover_pending_request_count",
    },
    {
      path: "car_receive",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "car-receive-dashboard" */
          "../../feature/fleet/dashboard/FleetReceive.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.PARKING, roles.ADMIN],
      sidebarGroup: "parkingList",
      sidebarLabel: "Car Receive",
      countKey: "receive_pending_request_count",
    },
    {
      path: "recovery_dashboard",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "recovery-dashboard" */
          "../../feature/fleet/dashboard/Recovery.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.ADMIN, roles.RECOVER_AGENT],
      sidebarGroup: "parkingList",
      sidebarLabel: "Recovery",
      countKey: "recovery_pending_request_count",
    },

    {
      path: "assignable_today_car",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "assignable-today-car-dashboard" */
          "../../feature/fleet/dashboard/FleetAssignableToday.js"
        ),
      authorized: [
        roles.ONBOARDING,
        roles.HUB_MANAGER,
        roles.PARKING,
        roles.ADMIN,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
      ],
      sidebarGroup: "parkingList",
      sidebarLabel: "Auto assign List",
      countKey: "assignable_today_car_count",
    },

    {
      path: "vendor_approved_cars",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "vendor-approved-cars-dashboard" */
          "../../feature/fleet/dashboard/VendorFleetList.js"
        ).then((m) => ({
          default: () => React.createElement(m.default, { sidebarListClick: "" }),
        })),
      authorized: [roles.VENDOR],
    },
    {
      path: "procurement_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "procurement-dashboard" */
          "../../feature/fleet/dashboard/ProcurmentDashboad.js"
        ).then((m) => ({
          default: () => React.createElement(m.default, { sidebarListClick: "" }),
        })),
      authorized: [],
    },
  ],
  standalone: [
    {
      path: "/fleet/:fleetID/:sidebarListClick",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "fleet-onboarding-main" */
          "./fleet-onboarding-screen/FleetOnboardingMain.js"
        ),
      protected: true,
    },
    {
      path: "/fleet/:fleetID",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "fleet-onboarding-main" */
          "./fleet-onboarding-screen/FleetOnboardingMain.js"
        ),
      protected: true,
    },
  ],
};

export default fleetRoutes;
